export const UserRoleUnknown = 0;
export const UserRoleViewer = 1;
export const UserRoleEditor = 2;
export const UserRoleAdministrator = 3;
export const UserRoleOwner = 4;